/* eslint-disable react-hooks/exhaustive-deps */
import  {  useEffect, useState } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Grid,
  LinearProgress,
  Typography,
  Snackbar,
  Alert,
  InputAdornment,
  TextField,
} from "@mui/material";
import "./style.css";
import { AuthenticationApi } from "../../../../API/Authentication/LoginApi";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import "react-medium-image-zoom/dist/styles.css";
import AppHeader from "../../../../common/Pages/AppHeader/AppHeader";

const FleetDailyReport = () => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [totalCount, setTotalCount] = useState<any>();
  const [userRole, setUserRole] = useState<string | null>(null);
  const [helpDetailListData, setHelpDetailListData] = useState<any[]>([]);
  const [showErrorSnackbar, setShowErrorSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState<"success" | "error">(
    "success"
  );
  const [selectedStatus, setSelectStatus] = useState<string | null>(null);
  const [searchValInput, setSearchValInput] = useState("");

  const pageRange = 5;
  useEffect(() => {
    const role = localStorage.getItem("authority");
    setUserRole(role);
  }, []);

  const tableHeaderCellStyle = {
    fontWeight: 600,
    fontSize: "14px",
    color: "#455A64",
    font: "Rubik",
  };
  const tableBodyCellStyle = {
    fontWeight: 400,
    fontSize: "14px",
    color: "#000",
    font: "Rubik",
  };
  // Dummy data for tables

  const pageCount = Math.ceil(totalCount / rowsPerPage);
  const handlePageChange = (newPage: number) => {
    const newPageNumber = Math.max(1, Math.min(newPage + 1, pageCount));
    setPage(newPageNumber - 1);
  };
  const changeStatus = async (
    ticketId: number,
    newStatus: string,
    index: number
  ) => {
    try {
      const response = await AuthenticationApi.api.updateTicketStatus(
        ticketId,
        newStatus
      );

      setSnackbarSeverity("success");
      setSnackbarMessage("Ticket status updated successfully.");
      setShowErrorSnackbar(true);

      // Update local table data
      const updatedData = [...helpDetailListData];
      updatedData[index].ticketStatus = newStatus;
      setHelpDetailListData(updatedData);
    } catch (error: any) {
      console.error("Status update failed:", error);
      setSnackbarSeverity("error");
      setSnackbarMessage(error.message || "Error updating status.");
      setShowErrorSnackbar(true);
    }
  };

  useEffect(() => {
    AuthenticationApi.api
      ?.HelpTicketList(selectedStatus, page, rowsPerPage, searchValInput)
      .then((response) => {
        if (response.data.tickets.length > 0) {
          setHelpDetailListData(response.data.tickets);
          setTotalCount(response.data.totalPages);
        } else {
          setHelpDetailListData([]);
          setTotalCount(1);
        }
      })
      .catch((error) => {
        console.error("API call error: ", error);
      });
  }, [page, rowsPerPage, selectedStatus, searchValInput]);

  const renderPageNumbers = () => {
    const pagesToShow = Math.min(pageCount, pageRange);
    const startPage = Math.max(
      0,
      Math.min(page - Math.floor(pageRange / 2), pageCount - pagesToShow)
    );

    return Array.from({ length: pagesToShow }, (_, index) => {
      const pageNumber = startPage + index + 1;
      return (
        <span
          key={index}
          onClick={() => handlePageChange(pageNumber - 1)}
          className={page === pageNumber - 1 ? "active" : "unactive"}
          style={{ marginLeft: "6px" }}
        >
          {pageNumber}
        </span>
      );
    });
  };
  const handleClearSearch = () => {
    setSearchValInput("");
  };
  return (
    <div>
      <AppHeader />
      <div className="px-10">
        <div className="py-6">
          <Typography variant="h4">Help Ticket Dashboard</Typography>
        </div>
        <Box sx={{ bgcolor: "#3b3b3b", width: "100%" }}></Box>

        <div className="w-full flex bg-white min-h-80 box-shadow p-3 rounded-xl">
          <div className="w-full">
            <Grid
              container
              spacing={5}
              className="w-full flex justify-between items-center"
            >
              <Grid item md={3}>
                <div className="flex ml-4">
                  <h2 className="text-center ml-2 mx-1 mt-2 font-semibold text-2xl text-black pb-2">
                    Help Ticket details
                  </h2>
                </div>
              </Grid>
              <Grid item md={9}>
                <div className="flex mr-4">
                  <div className="flex w-full justify-end">
                  <div className="mr-3">
                      <TextField
                        placeholder="Search  By Mobile Number"
                        id="outlined-basic"
                        variant="outlined"
                        onChange={(search: any) =>
                          setSearchValInput(search.target.value)
                        }
                        value={searchValInput}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <SearchIcon />
                            </InputAdornment>
                          ),
                          endAdornment: (
                            <InputAdornment
                              position="end"
                              onClick={handleClearSearch}
                            >
                              <ClearIcon style={{ cursor: "pointer" }} />
                            </InputAdornment>
                          ),
                          style: { height: "40px", borderRadius: "25px" },
                        }}
                        // onKeyDown={handleKeyPress}
                      />
                    </div>
                    <div>
                      <label>Status </label>
                      <select
                        onChange={(date) => {
                          setSelectStatus(date.target.value);
                        }}
                        style={{
                          border: "2px solid",
                          padding: "5px 10px",
                          borderRadius: "5px",
                        }}
                      >
                        <option value=""> All</option>
                        <option value="PENDING">Pending</option>
                        <option value="APPROVED">Approved</option>
                        <option value="REJECTED">Rejected</option>
                      </select>
                    </div>
                  </div>
                </div>
              </Grid>
            </Grid>
            <hr className="my-4" />

            <TableContainer style={{ width: "100%", overflowX: "auto" }}>
              {!helpDetailListData ? ( // Check if API response is still undefined (loading)
                <LinearProgress />
              ) : typeof helpDetailListData === "string" ? ( // If API returns "No Data Found" as a string
                <Typography style={{ textAlign: "center", padding: "10px" }}>
                  No data available
                </Typography>
              ) : helpDetailListData.length === 0 ? ( // If the array is empty
                <Typography style={{ textAlign: "center", padding: "10px" }}>
                  No data available
                </Typography>
              ) : (
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell
                        style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                        sx={{ minWidth: 120 }}
                      >
                        User Id
                      </TableCell>
                      <TableCell
                        style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                        sx={{ minWidth: 150 }}
                      >
                        Ticket ID
                      </TableCell>
                      <TableCell
                        style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                        sx={{ minWidth: 110 }}
                      >
                        Type
                      </TableCell>
                      <TableCell
                        style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                        sx={{ minWidth: 110 }}
                      >
                        Name
                      </TableCell>
                      <TableCell
                        style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                        sx={{ minWidth: 100 }}
                      >
                        Mobile
                      </TableCell>
                      <TableCell
                        style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                        sx={{ minWidth: 100 }}
                      >
                        Status
                      </TableCell>
                      <TableCell
                        style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                        sx={{ minWidth: 100 }}
                      >
                        Action
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {helpDetailListData.map((item: any, index: any) => (
                      <TableRow key={index}>
                        <TableCell
                          style={{ ...tableBodyCellStyle, textAlign: "center" }}
                        >
                          {item.userId}
                        </TableCell>
                        <TableCell
                          style={{ ...tableBodyCellStyle, textAlign: "center" }}
                        >
                          {item.ticketId}
                        </TableCell>

                        <TableCell
                          style={{ ...tableBodyCellStyle, textAlign: "center" }}
                        >
                          {item.ticketType}
                        </TableCell>
                        <TableCell
                          style={{ ...tableBodyCellStyle, textAlign: "center" }}
                        >
                          {item.riderName}
                        </TableCell>
                        <TableCell
                          style={{ ...tableBodyCellStyle, textAlign: "center" }}
                        >
                          {item.mobile}
                        </TableCell>
                        <TableCell
                          style={{ ...tableBodyCellStyle, textAlign: "center" }}
                        >
                          <p
                            style={{
                              color:
                                item.ticketStatus === "PENDING"
                                  ? "#ffda60"
                                  : item.ticketStatus === "APPROVED"
                                  ? "green"
                                  : item.ticketStatus === "REJECTED"
                                  ? "red"
                                  : "inherit",
                              fontWeight: "bold",
                            }}
                          >
                            {item.ticketStatus}
                          </p>
                        </TableCell>
                        <TableCell
                          style={{ ...tableBodyCellStyle, textAlign: "center" }}
                        >
                          {item.ticketStatus === "PENDING" ? (
                            <select
                              value={item.status || ""}
                              onChange={(e) =>
                                changeStatus(
                                  item.ticketId,
                                  e.target.value,
                                  index
                                )
                              }
                              style={{ border: "1px solid", padding: "3px" }}
                            >
                              <option value="" disabled>
                                Select Satuts
                              </option>
                              <option value="APPROVED">Approved</option>
                              <option value="REJECTED">Rejected</option>
                            </select>
                          ) : (
                            <p
                            style={{
                              color:
                                item.ticketStatus === "PENDING"
                                  ? "#ffda60"
                                  : item.ticketStatus === "APPROVED"
                                  ? "green"
                                  : item.ticketStatus === "REJECTED"
                                  ? "red"
                                  : "inherit",
                              fontWeight: "bold",
                            }}
                          >
                            {item.ticketStatus}
                          </p>
                          )}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              )}
            </TableContainer>

            <div className="pl-2 pt-4 pb-2 pr-16">
              <div
                className="pagination"
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <div>
                  <button
                    onClick={() => handlePageChange(page - 1)}
                    disabled={page === 0}
                    style={{
                      fontFamily: "Rubik",
                      fontSize: "20px",
                      marginRight: "6px",
                    }}
                  >
                    {"<"}
                  </button>
                  {renderPageNumbers()}
                  <button
                    onClick={() => handlePageChange(page + 1)}
                    disabled={page >= pageCount - 1}
                    style={{
                      fontFamily: "Rubik",
                      fontSize: "20px",
                      marginLeft: "6px",
                    }}
                  >
                    {">"}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <Snackbar
            open={showErrorSnackbar}
            autoHideDuration={6000}
            onClose={() => setShowErrorSnackbar(false)}
          >
            <Alert
              onClose={() => setShowErrorSnackbar(false)}
              severity={snackbarSeverity}
            >
              {snackbarMessage}
            </Alert>
          </Snackbar>
        </div>
        <Box sx={{ bgcolor: "background.paper", width: "100%" }}></Box>
      </div>
    </div>
  );
};

export default FleetDailyReport;
